import { createNamespacedHelpers } from 'vuex';

import SkeletonLoadingImage from '../SkeletonLoadingImage/SkeletonLoadingImage.vue';

const cameraMapper = createNamespacedHelpers('detector/camera');
const GOOD_CLASS = '0';

export default {
	name: 'ImageItem',

	components: {
		SkeletonLoadingImage,
	},

	data() {
		return {
			GOOD_CLASS: GOOD_CLASS,
		};
	},

	computed: {
		...cameraMapper.mapState(['isDetecting'])
	},

	props: {
		image: {
			type: Object,
		},
		idx: {
			type: Number,
		},
	},

	methods: {
		onChooseImage() {
			this.$emit('choose-image', this.idx);
		},
	},
};
